<template>
	<div class="row contentblock">
		<div class="columns column8">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column4">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	padding: 0;
	background: var(--secondary-background-color);
	gap: 24px;
	align-items: stretch;
	margin-bottom: 24px;

	.columns {
		padding: 0;
	}

	.column4 {
		background: var(--primary-background-color);
		width: calc(100% / 12 * 4 - 12px);
		flex-grow: 1;
		display: flex;
		flex-flow: column;
		justify-content: center;
		padding-top: 24px;

		:deep(h3) {
			text-transform: uppercase;
			font-size: 40px;
			line-height: 50px;
		}

		:deep(p) {
			font-size: 18px;
		}

		:deep(.button) {
			padding: 5px 50px;
		}
	}

	.column8 {
		width: calc(100% / 12 * 8 - 12px);
	}

	&:nth-child(even) {
		flex-direction: row-reverse;
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.contentblock-content {
		padding: 70px 50px;
		display: flex;
		flex-flow: column;
		justify-content: space-between;
		height: 100%;
	}
}

@media (max-width: 1550px) {
	.contentblock {
		.contentblock-content {
			padding: 10px 40px;
		}
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.column4 {
			width: 100%;
			padding: 32px 0 !important;
		}

		.column8 {
			width: 100%;
		}

		.contentblock-content {
			padding: 10px 30px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.column4 {
			padding: 0 !important;
		}
	}
}
</style>
